// ---Third-party imports
import {useMemo} from 'react'
import {bindActionCreators} from 'redux'
import {useDispatch, useSelector} from 'react-redux'

// ---Framework imports
import {isArray, isString} from 'ldash'
import {Actions} from 'uix/registries'
import log from 'uix/logging'

export {useSelector, useDispatch}

// https://react-redux.js.org/next/api/hooks#recipe-useactions
let _useActions = (actions, deps) => {
  let dispatch = useDispatch()
  return useMemo(() => {
    if (isArray(actions)) {
      return actions.map(a => bindActionCreators(a, dispatch))
    }
    // either scalar or dict
    return bindActionCreators(actions, dispatch)
  }, deps)
}

const getAction = name => {
  let action = Actions[name]
  if (!action) {
    log.error('unknown action name: %o', name)
    action = () => ({type: 'NO_OP', payload: {}})
  }
  return action
}

export const useActions = arg => {
  if (!arg) {
    // we dont know anything, so we wrap all and emit them as a dict
    arg = Actions
  }
  if (isString(arg)) {
    return _useActions(getAction(arg))
  } else if (isArray(arg) && isString(arg[0])) {
    return _useActions(arg.map(e => getAction(e)))
  }
  return _useActions(arg)
}
